import {createMuiTheme} from "@material-ui/core";

const theme = (primary, secondary) => createMuiTheme({
    palette: {
        common: {
            blue: primary,
        },
        primary: {
            main: primary,
        },
        secondary: {
            main: secondary
        },
        ternary: {
            main: '#B00020'
        }
    },
    typography: {
        h6: {
            fontFamily: 'Roboto',
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '1rem',
        },
        subtitle1: {
            fontFamily: 'Roboto',
        },
        body2: {
            fontFamily: 'Roboto',
            color: '#FFF',
            fontSize: '0.8rem',

        },
        h5: {
            fontFamily: 'Roboto',
            color: 'gray',
            fontSize: '0.8rem'
        }
    },
    overrides: {
        MuiListItem: {
            root: {
                '&$button': {
                    "&:hover": {
                        backgroundColor: "rgb(221,221,211)",
                        // color: '#FFF'
                    },
                },
                "&$selected": {
                    color: primary,
                },
            },

        },
        MuiTab: {
            root: {
                padding: 0,
                '&:hover': {
                    backgroundColor: 'rgb(221,221,211)'
                }
            }
        },
    },
    mixins: {
        toolbar: {
            minHeight: 0
        }
    }
});

export default theme;
